module.exports = __webpack_public_path__ + "img/dining-program-banner.102c2bc5.jpg";